/**
 * スマホメニューの処理
 */

import { backfaceFixed } from '../function/backfaceFixed';

export default class DrawerMenu {
  constructor() {
    this.toggleButton = document.querySelector('#js-hamburger-menu');
    this.drawerMenu = document.querySelector('#js-drawer-menu');
    if (!this.toggleButton || !this.drawerMenu) return;
    this.openClass = 'is-menu-open';
    this.init();
  }

  /**
   * メニューを開く/閉じる
   */
  toggle() {
    if (document.body.classList.contains(this.openClass)) {
      document.body.classList.remove(this.openClass);
      backfaceFixed(false);
      return;
    }
    document.body.classList.add(this.openClass);
    backfaceFixed(true);
  }

  addEvent() {
    this.toggleButton.addEventListener('click', (e) => {
      this.toggle();
    });
  }

  init() {
    this.addEvent();
  }
}
